import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiService from '../services/api';
import toast from 'react-hot-toast';
import LoadingSpinner from './LoadingSpinner';

const OAuthCallback: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    const handleOAuthCallback = async (token: string, userId: string) => {
      try {
        
        
        // Store the token
        localStorage.setItem('access_token', token);

        
        // Wait a moment to ensure localStorage is updated
        await new Promise(resolve => setTimeout(resolve, 100));

        // Get user information

        const user = await apiService.getCurrentUser();

        
        // Login with token and user data
        login({ access_token: token, token_type: 'bearer', expires_in: 1440 }, user);

        
        // Wait a moment for the auth context to update
        await new Promise(resolve => setTimeout(resolve, 500));
        
        toast.success('Login successful!');
        navigate('/');
      } catch (error: any) {
        console.error('OAuth callback error:', error);
        console.error('Error response:', error.response);
        toast.error(error.response?.data?.detail || 'Google login failed');
        localStorage.removeItem('access_token');
        navigate('/login');
      }
    };


    
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userId = urlParams.get('user_id');
    const error = urlParams.get('error');



    if (error) {
      toast.error(`Google login failed: ${error}`);
      // Clean up URL parameters
      window.history.replaceState({}, document.title, window.location.pathname);
      navigate('/login');
      return;
    }

    if (token && userId) {
      handleOAuthCallback(token, userId);
      // Clean up URL parameters
      window.history.replaceState({}, document.title, window.location.pathname);
    } else {
      // No OAuth parameters, redirect to login
      navigate('/login');
    }
  }, [login, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-4 text-gray-600">Processing authentication...</p>
      </div>
    </div>
  );
};

export default OAuthCallback; 